import { AxiosResponse } from "axios";
import axios from "./AxiosService";

export interface LabwareType {
  labwareTypeId: number;
  labwareTypeCode: string;
  arrayMethodPlateRoleId: number;
  minLabwareVolume: number;
  maxLabwareVolume: number;
  defaultLabwareVolume: number;
}

export interface AcceptablePlateType {
  labwareType: LabwareType;
}

export interface GetASAMAndPlateInfoData {
  acceptablePlateTypes: AcceptablePlateType[];
  arraySystemAutomationMethodId: number | null;
  system: number | null;
}

export interface Twelve24TCWorklistService {
  getASAMAndPlateInfo(
    methodReservationId: string
  ): Promise<AxiosResponse<GetASAMAndPlateInfoData>>;
}

export default {
  async getASAMAndPlateInfo(methodReservationId: string) {
    const params = new URLSearchParams();
    params.append("methodReservationId", methodReservationId);

    return axios.get<GetASAMAndPlateInfoData>(
      "api/Twelve24TCWorklist/GetASAMAndPlateInfo",
      { params }
    );
  },
} as Twelve24TCWorklistService;
